import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { type ProductDetail } from '../../../../../../../generated/frontend'
import { Product } from '../../ProductDetails/Product'
import styles from '../ComparisonTableContent.module.scss'

export const ComparisonPageProducts: FunctionComponent<ComparisonPageProductProps> = ({
  productDetailsForComparison,
  taxonomySlug,
  hasOneProductBadge,
  isDesktopOrAbove,
  isPaidMember,
  totalProductColumns,
  tooltipOpenHandler,
}) => (
  <section className={classnames(styles.productDetails, styles.section)}>
    <div className={styles.filler} />
    {productDetailsForComparison.map((productDetail) => (
      <Product
        key={productDetail?.businessKey}
        hasOneProductBadge={hasOneProductBadge}
        taxonomySlug={taxonomySlug}
        tooltipOpenHandler={tooltipOpenHandler}
        tag="div"
        {...productDetail}
        productScoreGauge={{ ...productDetail.productScoreGauge, variant: 'default' }}
        isPaidMember={isPaidMember}
      />
    ))}
    {isDesktopOrAbove && productDetailsForComparison.length < totalProductColumns && (
      <div className={styles.filler} />
    )}
  </section>
)

type ComparisonPageProductProps = {
  productDetailsForComparison: ProductDetail[]
  taxonomySlug: string
  hasOneProductBadge: boolean
  isDesktopOrAbove: boolean
  isPaidMember: boolean
  totalProductColumns: number
  tooltipOpenHandler: () => void
}
